// src/services/admin/HomepageSectionSettingServices.js
import API from "../../api/apiAdmin";

export const HomepageSectionSettingServices = {
    getSettings: async () => {
        try {
            const response = await API.get("/admin/homepage-sections/");
            return response.data;
        } catch (error) {
            throw error.response ? error.response.data : new Error("Network error");
        }
    },

    updateSettings: async (payload) => {
        try {
            // JSON body - no file upload for this setting (same as music_page_setting)
            const response = await API.put("/admin/homepage-sections/", payload, {
                headers: { "Content-Type": "application/json" },
            });
            return response.data;
        } catch (error) {
            throw error.response ? error.response.data : new Error("Network error");
        }
    },
};
